import React, { CSSProperties, ElementType, FC, HTMLAttributes } from 'react'
import './TitlePage.css'
import pinkIcon from '../../../img/icons/VectorPink.png'
import { Logo } from '../iconsComponent'

interface iTitlePage extends HTMLAttributes<HTMLOrSVGElement> {
    as: ElementType;
    title: string,
    className?: string,
    classNameLogo?: string,
    style?: CSSProperties
    withLogo?: boolean
}

export const TitlePage: FC<iTitlePage> = ({ title, className, style, withLogo, as: TAG, classNameLogo }) => {
    return (
        <>
            <div className='d-flex align-items-center w-100 '>
            <TAG style={style} className={`${className ?? ""} title-Page m-0 fw-700 w-100`}>
                {withLogo &&
                    <svg viewBox="0 0 760.67 313.36" className={`${classNameLogo ?? ""} title-logo`}>
                        <polygon points="264.17 -314.5 137.14 -188.51 611.08 282.67 738.11 156.68 264.17 -314.5" fill="#FF3F6B" />
                        <polygon points="-23.19 347.22 103.42 473.63 264.91 314.13 138.29 187.73 -23.19 347.22" fill="#FF3F6B" />
                        <polygon points="26.09 -237.48 -100.94 -111.49 858.5 842.35 985.53 716.35 26.09 -237.48" fill="#FF3F6B" />
                    </svg>
                }
            <span className='m-0 p-0'>{title}</span> 
            </TAG>
        </div >
        </>

    )
}
